const daysOffRequest = {
    0: {
        name: 'Edit Days Off Request',
        authRule: 'editDayTypeRequest'
    }
};

export default daysOffRequest;
